const { Enum } = require('solclient-eskit');

// Enum name, regexp, enum value, TE applicable
const nameChecks = [
  ["EMPTY_STRING", /^$/, "Zero length", true],
  ["LT", /</, "Less than sign (<)", true],
  ["GT", />/, "Greater than sign (>)", true],
  ["ASTERISK", /\*/, "Asterisk (*)", true],
  ["QUESTION_MARK", /\?/, "Question mark (?)", true],
  ["AMPERSAND", /&/, "Ampersand (&)", true],
  ["SEMICOLON", /;/, "Semicolon (;)", true],
  ["LEADING_SLASH", /^\//, "Starts with a slash (/).", false],
  ["TRAILING_SLASH", /\/$/, "Ends with a slash (/).", false],
  ["DOUBLE_SLASH", /\/\//, "Empty level (//)", false],
  ["TOO_LONG", /.{200,}/, "Longer than 200 characters", true],
  //["NO_ISSUE", undefined, ""]
];

/**
 * The most frequent problems with endpoint names.
 *
 * @enum {string}
 * @namespace
 * @memberof solace
 */
const EndpointNameComplaint = {
  EMPTY_STRING: "Zero length",
  LT: "Less than sign (<)",
  GT: "Greater than sign (>)",
  ASTERISK: "Asterisk (*)",
  QUESTION_MARK: "Question mark (?)",
  AMPERSAND: "Ampersand (&)",
  SEMICOLON: "Semicolon (;)",
  LEADING_SLASH: "Starts with a slash (/).",
  TRAILING_SLASH: "Ends with a slash (/).",
  DOUBLE_SLASH: "Empty level (//)",
  TOO_LONG: "Longer than 200 characters",
  NO_ISSUE: ""
};

//This should work, but the typescript generator doesn't like it.
/*
const EndpointNameComplaint = {};
nameChecks.forEach((triplet)=>{
  EndpointNameComplaint[triplet[0]] = triplet[2];
})
*/

function explainInvalidEndpointName(name, isTE) {
  //complaints are ordered by probability
  for (i in nameChecks) {
    const triplet = nameChecks[i];
    if (isTE && !triplet[3]) {
      // Slash-related issues are queue only, so those rules are marked "false" in the check list.
      continue;
    }
    if (name.match(triplet[1])) {
      return triplet[2];
    }
  }
  // This is an empty string because it's falsy.
  return EndpointNameComplaint.NO_ISSUE;
} 	

module.exports.EndpointNameComplaint = Enum.new(EndpointNameComplaint);
//module.exports.EndpointNameComplaint = EndpointNameComplaint;
module.exports.explainInvalidEndpointName = explainInvalidEndpointName;
